export const UPS_SERVICES = [
  { label: "Next Day Air", value: "01" },
  { label: "2nd Day Air", value: "02" },
  { label: "Ground", value: "03" },
  { label: "Express", value: "07" },
  { label: "Expedited", value: "08" },
  { label: "UPS Standard", value: "11" },
  { label: "3 Day Select", value: "12" },
  { label: "Next Day Air Saver", value: "13" },
  { label: "UPS Next Day Air® Early", value: "14" },
  { label: "UPS Worldwide Economy DDU", value: "17" },
  { label: "Express Plus", value: "54" },
  { label: "2nd Day Air A.M.", value: "59" },
  { label: "UPS Saver", value: "65" },
  { label: "First Class Mail", value: "M2" },
  { label: "Priority Mail", value: "M3" },
  { label: "Expedited MaiI Innovations", value: "M4" },
  { label: "Priority Mail Innovations", value: "M5" },
  { label: "Economy Mail Innovations", value: "M6" },
  { label: "Mail Innovations (MI) Returns", value: "M7" },
  { label: "UPS Access Point™ Economy", value: "70" },
  { label: "UPS Worldwide Express Freight Midday", value: "71" },
  { label: "UPS Worldwide Economy DDP", value: "72" },
  { label: "UPS Express®12:00", value: "74" },
  { label: "UPS Heavy Goods", value: "75" },
  { label: "UPS Today Standard", value: "82" },
  { label: "UPS Today Dedicated Courier", value: "83" },
  { label: "UPS Today Intercity", value: "84" },
  { label: "UPS Today Express", value: "85" },
  { label: "UPS Today Express Saver", value: "86" },
  { label: "UPS Worldwide Express Freight", value: "96" },
];
